import cs from "classnames";
import { ErrorMessage, Field, FieldProps } from "formik";
import { useEffect, useState } from "react";
import { v4 } from "uuid";
import { ErrorMsg, LabelText } from "../../components";
import { FormCheckboxGroupI } from "../../types/formTypes";
import "./formCheckboxGroup.scss";

interface sortedDataI {
  value: string;
  label: string;
  id: string;
}

// the value of this component in the formik form should be an array
const FormCheckboxGroup: React.FC<FormCheckboxGroupI> = ({
  label,
  name,
  data,
  optionLabel,
  optionValue,
  className,
  labelVariant = "black",
}) => {
  const [sortedData, setSortedData] = useState<sortedDataI[]>([]);

  useEffect(() => {
    const opts = data.map((item) => {
      let optionData: sortedDataI = {
        value: item[optionValue],
        label: item[optionLabel],
        id: v4(),
      };

      return optionData;
    });

    setSortedData(opts);
  }, [data, optionLabel, optionValue]);

  const classes = cs("formCheckboxGroup", { [`${className}`]: className });
  const labelClasses = cs("formCheckboxGroup__label", {
    black: labelVariant === "black",
    white: labelVariant === "white",
  });

  return (
    <div className={classes}>
      {label && <LabelText id={name}>{label}</LabelText>}
      <Field name={name}>
        {({ field }: FieldProps) => {
          return (
            <div className="formCheckboxGroup__checkBoxes">
              {sortedData.map((item) => (
                <div key={item.id} className="formCheckboxGroup__checkbox">
                  <input
                    className="formCheckboxGroup__input"
                    type="checkbox"
                    id={item.id}
                    {...field}
                    value={item.value}
                    checked={field.value.includes(item.value)}
                  />
                  <label className={labelClasses} htmlFor={item.id}>
                    {item.label}
                  </label>
                </div>
              ))}
            </div>
          );
        }}
      </Field>
      <ErrorMessage name={name} component={ErrorMsg} />
    </div>
  );
};

export default FormCheckboxGroup;
